/**
 * ヘッダーの処理
 */

export default class Header {
  constructor() {
    this.header = document.querySelector('#js-header');
    if (!this.header) return;
    this.navs = document.querySelectorAll('#js-header-nav a');
    this.init();
  }

  /**
   * スクロールしたらヘッダースタイルを変えるために、起点要素を生成＆監視
   */
  observer() {
    const triggerId = 'js-add-header-observer-trigger';
    // 起点要素を生成
    document.body.insertAdjacentHTML('beforeend', `<div id="${triggerId}"></div>`);
    // 起点要素取得してスタイル付与
    const triggerElm = document.querySelector(`#${triggerId}`);
    Object.assign(triggerElm.style, {
      position: 'absolute',
      top: '99vh',
    });
    // 交差した時にbodyの属性を変える
    const doWhenIntersect = entries => {
      document.body.setAttribute('data-header-scrolled', String(!entries[0].isIntersecting));
    }
    // 監視実行
    const observer = new IntersectionObserver(doWhenIntersect, {});
    observer.observe(triggerElm);
  }

  /**
   * カレントページのナビのclass変える
   */
  setCurrentNav() {
    this.navs.forEach(link => {
      const href = link.getAttribute('href');
      const hrefUrl = new URL(href, window.location.origin);
      const hrefPath = hrefUrl.pathname;
      const currentPath = window.location.pathname;
      const currentClass = 'is-current';
      if (currentPath.startsWith(hrefPath) && (hrefPath !== '/' || currentPath === '/')) {
        link.classList.add(currentClass);
        return;
      }
      link.classList.remove(currentClass);
    });
  }

  init() {
    this.observer();
    this.setCurrentNav();
  }
}
